<template lang="html">
<div >
  <rate-sidebar :rate="rate" @success="$emit('reload')"/>
  <vs-table :data="data">
    <template slot="header">
      <vs-row class="mb-3">
        <vs-col vs-w="3">
          <vs-button
            color="success"
            class="mx-2"
            icon-pack="feather"
            icon="icon-plus"
            @click="add"
          >
            {{ $t('new') }}
          </vs-button>
        </vs-col>
      </vs-row>
    </template>
    <template slot="thead">
      <!-- <th class="qb-sticky" :style="{background:'white'}"></th> -->
      <vs-th class="text-center">
        {{ $t('from_or_equal') | capitalize }}
      </vs-th>
      <vs-th class="text-center">
        {{ $t('to_or_equal') | capitalize }}
      </vs-th>
      <vs-th class="text-center">
        {{ $tc('rate') | capitalize }}
      </vs-th>
      <th class="qb-sticky">
        {{ $t('actions') }}
      </th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr :key="i" v-for="(tr, i) in data">
        <vs-td>{{ formatNumber(data[i].FromGTorEqual,2) }}</vs-td>
        <vs-td>{{ formatNumber(data[i].ToLTorEqual,2) }}</vs-td>
        <vs-td>{{ formatNumber(data[i].Rate,4) }}</vs-td>
        <vs-td>
          <div class="text-center">
          <action-icon icon="EditIcon" :tooltip="$t('edit')" @click="edit(data[i])"/>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</div>
</template>

<script>
import RateSidebar from './RateSidebar'
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import mixins from '@/mixins'
export default {
  components:{
    ActionIcon,
    RateSidebar
  },

  data:()=>({
    defaultRate:{
      clientId:'',
      id:'',
      fromOrEqual:'',
      toOrEqual:'',
      rate:''
    },
    rate:{
      clientId:'',
      id:'',
      fromOrEqual:'',
      toOrEqual:'',
      rate:''
    }
  }),

  methods:{
    add(){
      this.rate = Object.assign({},this.defaultRate,{ clientId:this.id })
      this.$store.dispatch('toggleSidebar', 'rate')
    },

    edit(data){
      this.rate.clientId = this.id
      this.rate.id = data.Rate
      this.rate.fromOrEqual = data.FromGTorEqual
      this.rate.toOrEqual = data.ToLTorEqual
      this.rate.rate = data.Rate
      this.$store.dispatch('toggleSidebar', 'rate')
    }
  },
  mixins:[mixins],
  props:{
    data:{
      default: () => []
    },

    id:{
      required:true

    }
  }
}
</script>

<style lang="css" scoped>
</style>
